<div class="fixed inset-0 bg-gray-700 bg-opacity-75 flex justify-center items-center z-20">
    <div class="bg-white shadow-lg rounded p-4 max-w-md w-full relative">
        <h1 class="font-bold text-xl">{{title}}</h1>
        <span class="mt-1 inline text-primary-300 text-sm">Link parent of </span><span
            class="text-primary-500 text-sm font-semibold">{{ student?.name }}</span>
        @if(searchForm.errors?.['exists']) {
        <p class="text-red-500 text-sm font-normal my-1">Parent Student Link Exists</p>
        }
        @if(searchForm.errors?.['searchFailed']) {
        <p class="text-red-500 text-sm font-normal my-1">Search failed. Please try after a while</p>
        }
        <form [formGroup]="searchForm" (ngSubmit)="searchParents()" class="mt-4">
            <div class="flex items-stretch flex-row">
                <input type="text" autocomplete="off" formControlName="searchInput" name="searchInput"
                    placeholder="Search and Select prayer requester's name"
                    class="border-0 placeholder-blueGray-300 text-blueGray-600 bg-white rounded-l text-sm shadow focus:outline-none grow py-2 px-3 ease-linear transition-all duration-150" />
                <button type="button" (click)="searchParents()" [disabled]="isSearching"
                    class="bg-primary-500 text-white text-sm px-4 py-2 shadow border-1 border-primary-500 focus:outline-none whitespace-nowrap w-fit rounded-r flex items-center h-full">
                    @if (!isSearching) {
                    <i class="fa fa-search mr-2"></i>
                    } @else {
                    <svg class="animate-spin -ml-1 mr-2 h-5 w-5 text-white inline" xmlns="http://www.w3.org/2000/svg"
                        fill="none" viewBox="0 0 24 24">
                        <circle class="opacity-25" cx="12" cy="12" r="10" stroke="currentColor" stroke-width="4">
                        </circle>
                        <path class="opacity-75" fill="currentColor"
                            d="M4 12a8 8 0 018-8V0C5.373 0 0 5.373 0 12h4zm2 5.291A7.962 7.962 0 014 12H0c0 3.042 1.135 5.824 3 7.938l3-2.647z">
                        </path>
                    </svg>
                    }
                    Search
                </button>
            </div>
            <div
                class="{{ searchForm.get('searchInput')?.invalid && (searchForm.get('searchInput')?.dirty || searchForm.get('searchInput')?.touched) ? 'visible' : 'invisible'}}  pt-1 h-4 text-red-500 text-xs">
                @if(searchForm.get('searchInput')?.errors?.['required']) {
                <p>
                    Value is required
                </p>
                } @else if(searchForm.get('searchInput')?.errors?.['minlength']) {
                <p>
                    Minimum length is {{searchForm.get('searchInput')?.errors?.['minlength']?.requiredLength}}
                    characters
                </p>
                }@else if(searchForm.get('searchInput')?.errors?.['maxlength']) {
                <p>
                    Maximum length is {{searchForm.get('searchInput')?.errors?.['maxlength']?.requiredLength}}
                    characters
                </p>
                }
            </div>
        </form>

        @for (parent of parentsFound; track $index) {
        <div class="bg-white rounded flex flex-row pb-4">
            <div class="flex flex-row justify-start content-center">
                <input type="checkbox" (change)="onChangeOption(parent)" [value]="parent"
                    [checked]="selectedParent?.id === parent.id"
                    class="rounded my-auto outline-none ring-0 focus:outline-none focus:ring-0">
            </div>
            <div class="flex flex-row items-center ml-4">
                <div class="inline-block flex-none">
                    @if (parent.photoURL) {
                    <img [src]="parent.photoURL"
                        class="min-h-12 max-h-12 max-w-12 min-w-12 bg-gray-100 object-cover rounded-full border-none" />
                    }
                    @else {
                    <div
                        class="bg-primary-100 uppercase text-primary-500 text-base flex justify-center items-center text-center h-12 w-12 rounded-full">
                        {{ parent.name | initials }}
                    </div>
                    }
                </div>
                <div class="flex-1 inline-flex flex-span ml-3 text-sm font-bold text-blueGray-600">
                    <span>{{parent.name}}</span>
                </div>
            </div>
        </div>
        } @empty {
        <div class="px-6 pb-4 text-sm text-center font-semibold border-0 whitespace-nowrap">
            No data available
        </div>
        }
        <div class="flex flex-row gap-4 justify-end">
            <button type="button" (click)="onCancel()"
                class="text-primary-500 px-4 py-2 focus:outline-none">Cancel</button>
            <button (click)="submit()" [disabled]="isSearching || selectedParent == null"
                class="bg-primary-500 disabled:bg-primary-100 hover:bg-primary-300 text-white rounded font-semibold px-4 py-2 focus:outline-none">{{action}}</button>
        </div>

    </div>